import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import NotificationSettingsTable from "../../components/admin/settings/NotificationSettingsTable";
import Role from "../../enums/Role";
import { PageContainer } from "@outpave/ds";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

const NotificationSettings: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(
    t("notificationSettings.notifications"),
  );
  const [activeTab, setActiveTab] = useState(0);

  const tabConfigurations = [
    {
      label: t("notificationSettings.users"),
      value: Role.Employee,
    },
    {
      label: t("notificationSettings.managers"),
      value: Role.Manager,
    },
    {
      label: t("notificationSettings.administrators"),
      value: Role.Admin,
    },
  ];

  const role = tabConfigurations[activeTab].value;

  return (
    <PageContainer
      title={t("notificationSettings.notifications")}
      breadcrumbs={breadcrumbs}
      tabs={{
        items: tabConfigurations.map((tab, index) => ({
          id: String(index),
          label: t(tab.label),
        })),
        activeId: String(activeTab),
        onChange: (id) => setActiveTab(Number(id)),
      }}
    >
      <NotificationSettingsTable userRole={role} />
    </PageContainer>
  );
};

export default NotificationSettings;
